import { message } from 'antd';
import _ from 'lodash';
import CryptoJS from 'crypto-js';
import { backendServer, backendServerInvestor } from '../variable';
import { getSessionStorage, SESSION_NAME } from './storage';

/**
 * 检验是否合法手机号
 * @param phoneNumber 手机号
 */
export const testPhoneNumber = phoneNumber => {
  const reg = /^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/;
  return reg.test(phoneNumber);
};

/**
 * 检验是否合法座机号
 */
export const testTelNumber = number => {
  const reg = /^0?1[3|4|5|8][0-9]\d{8}$/;
  return reg.test(number);
};

// 获取类似 2009-06-12 00:00:00 格式的年月日
// todo: 用moment，把这个方法干掉吧.
export const formatTime = date => {
  const year = date.getFullYear(); //年
  const month = date.getMonth() + 1; //月
  const day = date.getDate(); //日
  const hour = date.getHours(); //时
  const minute = date.getMinutes(); //分
  const second = date.getSeconds(); // 秒
  let clock = year + '-';
  if (month < 10) clock += '0';
  clock += month + '-';
  if (day < 10) clock += '0';
  clock += day;
  clock += ' ';
  if (hour < 10) clock += '0';
  clock += hour;
  clock += ':'
  if (minute < 10) clock += '0';
  clock += minute;
  clock += ':'
  if (second < 10) clock += '0';
  clock += second;
  return clock;
};

// 金额，截取2位小数
export const formatMoney = money => {
  if (isNaN(money)) {
    money = 0;
  }
  return Number(money).toFixed(3).slice(0, -1);
};

// 金额，四舍五入2位小数
export const formatMoneyByRounded = money => {
  if (isNaN(money)) {
    money = 0;
  }
  return Number(money).toFixed(2);
};

/**
 * 根据对象value获取key
 * @param obj 对象
 * @param value 值
 */
export const getObjKey = (obj, value) => {
  const key = Object.keys(obj).find(key => obj[key] === value);
  return key;
};

/**
 * 上传uploadProps
 * @param url 地址
 * @param cb 回调函数
 */
export const uploadProps = (url, cb) => {
  return {
    name: 'file',
    action: url,
    onChange(info) {
      if (info.file.status === 'done' && info.file.response.success) {
        cb(_.get(info.file.response.data, 'filePath', ''));
        message.success('上传成功');
      } else if (info.file.status === 'done' && !info.file.response.success) {
        message.error(`上传失败,${info.file.response.msg},请重新上传`);
      } else if (info.file.status === 'error') {
        message.error('上传失败,请重新上传');
      }
    },
    showUploadList: false
  };
};

/**
 * 把err用接口名包装一下
 * @param err
 * @param name  接口名字
 * @returns {*}
 */
export const errorHandler = (err, name) => {
  if (err.code !== undefined) {
    err.msg = name + ' ' + err.msg;
  } else {
    err = {
      success: false,
      code: -1,
      msg: name + ' 接口错误'
    };
  }
  return err;
};

/*
 * 截取后端返回的文件路径
 * @param url 文件路径
 */
export const interceptUrl = url => {
  return (url && url.split('_')[1]) || '';
};

/*
 * 截取并解码后端返回的文件路径
 * @param url 文件路径
 */
export const decodeInterceptUrl = url => {
  return (interceptUrl(url) && decodeURI(interceptUrl(url))) || '';
};

/*
 * 获取私有文件路径
 * @param fileName 文件路径
 */
export const ossPreviewUrl = fileName => {
  return (
    (fileName &&
      `${backendServerInvestor}/oss/preview?access_token=${getSessionStorage(
        SESSION_NAME.token
      )}&fileName=${fileName}`) ||
    ''
  );
};

export const getDownloadUrl = () => {
  return `${backendServer}/material/preview?access_token=${getSessionStorage(
    SESSION_NAME.token
  )}`;
};

/*
 * antd数字验证
 * @param rule
 * @param value 内容
 * @param callback 必传
 */
export const numberTest = (rule, value, callback) => {
  if (value && (isNaN(value) || parseFloat(value).toString() === 'NaN')) {
    callback('请输入数字！');
  }
  callback();
};

/*
 * antd 字符长度验证
 * @param rule
 * @param value 内容
 * @param callback 必传
 */
export const stringLenTest = (rule, value, callback) => {
  if (value && (value.trim().length > 100 || value.trim().length < 3)) {
    callback('文字长度在3-100之间！');
  }
  callback();
};

/**
 * 检验6-16位字母或者数字的交易密码
 */
export const testPassword = value => {
  const reg = /^[a-zA-Z0-9]{6,16}$/;
  return reg.test(value);
};

/**
 * 对象根据属性排序
 */
export const sortObj = obj => {
  var keys = Object.keys(obj);
  keys.sort();
  var rs = {};
  for (var i = 0; i < keys.length; i++) {
    var _key = keys[i];
    rs[_key] = obj[_key];
  }
  return rs;
};

/**
 * AES算法，用交易密码解密出私钥
 * 如果私钥返回''，说明交易密码错误。
 * @param encryptPrivateKey // 验证交易密码后返回的加密私钥
 * @param tradePassword // 交易密码
 * @returns {string} // 解密后的私钥
 */
export const decryptPrivateKeyWithAES = (encryptPrivateKey, tradePassword) => {
  const privateKeyBytes = CryptoJS.AES.decrypt(
    encryptPrivateKey,
    tradePassword
  );
  return privateKeyBytes.toString(CryptoJS.enc.Utf8);
};

/**
 * 上传Excel文件方法
 * @param data 上传的参数
 * @returns 组件上传所需的props
 */
export const uploadExcel = ({ projectId }, uploadOnchage) => {
  return {
    action: `${backendServerInvestor}/web/process/buy/component`,
    headers: {
      accessToken: getSessionStorage(SESSION_NAME.token)
    },
    data: {
      projectId
    },
    showUploadList: true,
    onChange: uploadOnchage
  };
};



// WEBPACK FOOTER //
// ./src/utils/methods.js